var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPink = function SvgPink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddii_pink)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9998 95C74.8527 95 94.9998 74.8528 94.9998 50C94.9998 25.1472 74.8527 5 49.9998 5C25.147 5 4.99984 25.1472 4.99984 50C4.99984 74.8528 25.147 95 49.9998 95Z",
    fill: "#E3C19A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.6112 50.019C90.6112 27.5887 72.4278 9.40525 49.9974 9.40525C27.567 9.40525 9.38363 27.5887 9.38363 50.019C9.38363 72.4494 27.567 90.6328 49.9974 90.6328C72.4278 90.6328 90.6112 72.4494 90.6112 50.019Z",
    fill: "#FBF4ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9997 88.0631C71.0212 88.0631 88.0625 71.0218 88.0625 50.0003C88.0625 28.9788 71.0212 11.9375 49.9997 11.9375C28.9781 11.9375 11.9369 28.9788 11.9369 50.0003C11.9369 71.0218 28.9781 88.0631 49.9997 88.0631Z",
    fill: "url(#paint0_linear_pink)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8469 51.3382C27.647 54.7334 37.4472 55.9447 46.8069 51.3382C56.1666 46.7318 69.5271 43.7036 77.3269 44.713C79.9828 45.1092 82.612 45.6669 85.2001 46.3831C83.9671 37.607 79.4906 29.6113 72.6533 23.9728C65.8161 18.3343 57.1143 15.4622 48.264 15.923C39.4136 16.3837 31.0571 20.1437 24.8423 26.4617C18.6274 32.7796 15.0053 41.1968 14.6903 50.0536C15.5895 50.5124 16.6356 50.8794 17.8469 51.3382Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0116 60.0578C21.8293 73.8588 35.6119 85.1639 49.89 85.1639C59.9288 85.0538 70.9585 79.5297 76.1706 72.6109C78.0059 64.9029 61.764 74.1708 49.89 74.024C35.1347 74.336 19.3884 53.2491 16.0116 60.0578Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddii_pink",
    x: -1.00016,
    y: -0.5,
    width: 102,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow",
    result: "effect4_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_pink",
    x1: 49.394,
    y1: 14.4151,
    x2: 50.5869,
    y2: 83.3282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0059"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pink.63e23710.svg";
export { ForwardRef as ReactComponent };